import StoriesModal from 'modules/Modals/Stories/StoriesModal'

export default StoriesModal
